'use client';

import { DataLayerWhere } from '@/modules/cart/services/data-layer-events/add-to-cart';
import { Carousel, CarouselContent, CarouselItem } from '@/modules/common/components/carousel';
import useIsMobile from '@/modules/common/hooks/useIsMobile';
import { CollectionCard } from '@/modules/product/components/collections/CollectionCard/CollectionCard';
import { CollectionProduct } from '@/modules/product/models/collection.interface';
import { ALGOLIA_SEARCH_INDEX } from '@/modules/product/services/consts';
import { DataLayerFeature } from '@/modules/product/services/data-layer-events/add-to-wishlist';

type BrandCollectionsProps = {
  collections?: {
    title: string;
    slug: string;
    description: string;
    image: string;
    products?: CollectionProduct[];
    designerId?: string;
  }[];
  brand?: string;
};

export const BrandCollections = ({ collections, brand }: BrandCollectionsProps) => {
  const isMobile = useIsMobile();

  if (!collections?.length) {
    return null;
  }

  return (
    <div className="mx-auto mb-10 w-full px-4 lg:mb-14 lg:px-8">
      <h2 className="mb-5 text-2xl font-bold lg:text-[28px]/[32px]">
        Collections featuring {brand}
      </h2>

      {isMobile ?
        <Carousel className="w-full lg:hidden">
          <CarouselContent>
            {collections.map((collection, index) => (
              <CarouselItem key={index} className="basis-4/5 lg:basis-1/3">
                <CollectionCard
                  description={collection.description}
                  feature={DataLayerFeature.Search}
                  image={collection.image}
                  itemListId={ALGOLIA_SEARCH_INDEX}
                  itemListName={'Search results'}
                  itemListType={'PLP'}
                  key={index}
                  products={collection.products}
                  slug={collection.slug}
                  title={collection.title}
                  variant="brand"
                  where={DataLayerWhere.Brand}
                  designerId={collection.designerId}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      : <ul className="hidden grid-cols-3 gap-4 lg:grid">
          {collections.map((collection, index) => (
            <li key={index}>
              <CollectionCard
                description={collection.description}
                feature={DataLayerFeature.Search}
                image={collection.image}
                itemListId={ALGOLIA_SEARCH_INDEX}
                itemListName={'Search results'}
                itemListType={'PLP'}
                key={index}
                products={collection.products}
                slug={collection.slug}
                title={collection.title}
                variant="brand"
                where={DataLayerWhere.Brand}
                designerId={collection.designerId}
              />
            </li>
          ))}
        </ul>
      }
    </div>
  );
};
